/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_StatsInputs */

const th_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติทั้งหมด →`)
};

const en_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All stats →`)
};

const ja_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全スタッツ →`)
};

const zh_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部数据 →`)
};

const es_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las estadísticas →`)
};

const pt_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as estatísticas →`)
};

const id_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua statistik →`)
};

const fr_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les statistiques →`)
};

const tl_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng istatistika →`)
};

const vi_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ thống kê →`)
};

const ko_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 기록 →`)
};

const de_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Statistiken →`)
};

const ru_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вся статистика →`)
};

const tr_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm istatistikler →`)
};

const it_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le statistiche →`)
};

const pl_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie statystyki →`)
};

const uk_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уся статистика →`)
};

const hi_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी आँकड़े →`)
};

const ar_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الإحصاءات ←`)
};

const ms_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua statistik →`)
};

const bn_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব পরিসংখ্যান →`)
};

const zh_tw2_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有數據 →`)
};

const zh_hk2_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有數據 →`)
};

const ur_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمام اعداد و شمار ←`)
};

const fa_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همهٔ آمار ←`)
};

const sw_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takwimu zote →`)
};

const nl_all_stats = /** @type {(inputs: All_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle statistieken →`)
};

/**
* | output |
* | --- |
* | "All stats →" |
*
* @param {All_StatsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const all_stats = /** @type {((inputs?: All_StatsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_StatsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_all_stats(inputs)
	if (locale === "ja") return ja_all_stats(inputs)
	if (locale === "zh") return zh_all_stats(inputs)
	if (locale === "es") return es_all_stats(inputs)
	if (locale === "pt") return pt_all_stats(inputs)
	if (locale === "id") return id_all_stats(inputs)
	if (locale === "fr") return fr_all_stats(inputs)
	if (locale === "tl") return tl_all_stats(inputs)
	if (locale === "vi") return vi_all_stats(inputs)
	if (locale === "ko") return ko_all_stats(inputs)
	if (locale === "de") return de_all_stats(inputs)
	if (locale === "ru") return ru_all_stats(inputs)
	if (locale === "tr") return tr_all_stats(inputs)
	if (locale === "it") return it_all_stats(inputs)
	if (locale === "pl") return pl_all_stats(inputs)
	if (locale === "uk") return uk_all_stats(inputs)
	if (locale === "hi") return hi_all_stats(inputs)
	if (locale === "ar") return ar_all_stats(inputs)
	if (locale === "ms") return ms_all_stats(inputs)
	if (locale === "bn") return bn_all_stats(inputs)
	if (locale === "zh-TW") return zh_tw2_all_stats(inputs)
	if (locale === "zh-HK") return zh_hk2_all_stats(inputs)
	if (locale === "ur") return ur_all_stats(inputs)
	if (locale === "fa") return fa_all_stats(inputs)
	if (locale === "sw") return sw_all_stats(inputs)
	if (locale === "nl") return nl_all_stats(inputs)
	return en_all_stats(inputs)
});